export const countries = [
  { label: 'United States of America', value: 'us' },
  { label: 'Canada', value: 'ca' },
  { label: 'Mexico', value: 'mx' },
  { label: 'Puerto Rico', value: 'pr' },
  { label: 'Bahamas', value: 'bh' },
];

export function convertCountryShortcode(shortcode) {
  if (shortcode === 'us') { return 'USA'; }

  const country = countries.find(c => c.value === shortcode);
  return country ? country.label : '';
}



// WEBPACK FOOTER //
// ./src/utils/countries.js